/** @format */

import {useTheme} from '@mui/material/styles';

import {CustomizedComponentProps} from '../types';

const CustomizedArea = ({offset, width, height}: CustomizedComponentProps) => {
  const theme = useTheme();

  const x = offset.left;
  const y = offset.top;
  const w = width - offset.left - offset.right;
  const h = height - offset.top - offset.bottom;

  return (
    <>
      <defs>
        <linearGradient id='chartBackgroundGradient' x1='0' y1='0' x2='0' y2='1'>
          <stop offset='75%' stopColor={theme.palette.semantic_dark!.surface.surface1} />
          <stop offset='100%' stopColor={theme.palette.semantic_dark!.surface.surface2} />
        </linearGradient>
      </defs>

      <rect x={x} y={y} width={w} height={h} rx={8} ry={8} fill='url(#chartBackgroundGradient)' />
    </>
  );
};

export default CustomizedArea;
